/** platformURL provided in translations interpolation */
const platformURL = 'https://app.bkbn.com'
export default platformURL